enum ActionTypes {
  OPEN_MODAL = 'careers/Shared/Modal/OPEN_MODAL',
  CLOSE_MODAL = 'careers/Shared/Modal/CLOSE_MODAL',
}

export const ApplicationModalId = 'applicationModal';

export default ActionTypes;